import { Http } from '@angular/http';
import { Injectable } from '@angular/core';
import { StorageServiceProvider} from '../storage-service/storage-service';
import { GlobalServiceProvider} from '../global-service/global-service';

@Injectable()
export class UserServiceProvider {
  
  private tokenBTCustomerAPI :string = 'tokenBTCustomerAPI';
  // private tokenTMSAPI :string = 'tokenTMSAPI';
  bss_api: String = this.globalServiceProvider.appConfig.bss_api;
  baseTmsURL: String = this.globalServiceProvider.appConfig.BaseApiTmsUrl;
  constructor(
    public http: Http,
    public storageServiceProvider: StorageServiceProvider,
    public globalServiceProvider: GlobalServiceProvider,
  ) {
    console.log('Hello UserServiceProvider Provider');
  }

  loadLoginUserData(){
    try {
      var token = this.storageServiceProvider.getToken(this.tokenBTCustomerAPI);
      if (token !== null) {
        var encoded = token.split('.')[1];
        var user = JSON.parse(window.atob(encoded));
        this.globalServiceProvider.setLoginUserData = user;
        // console.log('LoginUserData:', this.globalServiceProvider.getLoginUserData);
        return user;
      }
    } catch (error) {
      localStorage.clear();
    }
  }


  /**
   * Register - Customer Registration Page
   */
  register(user) {
    let result = null;
    return this.http
      .post(this.bss_api + '/btcutomer/public/registrationv3', user)
      .toPromise()
      .then(data => {
        result = data;
        return result._body;
      })
      .catch(
        err => {
          return err._body;
        }
      );
  }
  
  // updateUserTmsFCM(email, postData) {
  //   return this.http
  //     .put(this.baseTmsURL + "/usersfcm/" + email, postData)
  //     .toPromise()
  //     .then((data: any) => {
  //       return data._body;
  //     }
  //     )
  //     .catch(
  //       err => {
  //         console.log('err: ', err);
  //         return null;
  //       }
  //     );
  // }
}



// WEBPACK FOOTER //
// ./src/providers/user-service/user-service.ts